module.exports = __webpack_public_path__ + "img/1435103874.98a072f3.jpg";